import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { ROLE_SERVICE } from '../EndPoints';

export const roleAvailableTasks = createAsyncThunk('employeeRoles/roleAvailableTasks', async () => {
    const result = await apiInstance
        .get('task-service/get-all')
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const getAllroleEmployeesPageable = createAsyncThunk(
    'employeeRoles/getAllroleEmployeesPageable',
    async (body) => {
        const result = await apiInstance.post(
            `${ROLE_SERVICE.getAllroleEmployeesPageable}${body?.id}?key=${encodeURIComponent(body?.key || '')}`,
            body.pagination,
        );

        const { data, status } = result;

        return { data, status };
    },
);
export const getEmployeeRoles = createAsyncThunk(
    'employeeRoles/getEmployeeRoles',
    async (body, { dispatch, getState }) => {
        const result = await apiInstance
            .post(ROLE_SERVICE.getEmployeeRoles, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const getEmployesWithRole = createAsyncThunk(
    'employeeRoles/getEmployesWithRole',
    async (roleId, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${ROLE_SERVICE.getEmployesWithRole}${roleId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const getAllEmployees = createAsyncThunk('employeeRoles/getAllEmployees', async () => {
    const result = await apiInstance
        .get('employee-service/get-all/only-user-data')
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const removeRoleToUserByIds = createAsyncThunk('employeeRoles/removeRoleToUserById', async (body) => {
    const result = await apiInstance
        .put(ROLE_SERVICE.removeRoleToUserByIds, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const addUsersToRole = createAsyncThunk('employeeRoles/addUsersToRole', async (body) => {
    const result = await apiInstance
        .put(ROLE_SERVICE.addUsersToRole, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const creatRole = createAsyncThunk('employeeRoles/creatRole', async (body) => {
    const result = await apiInstance
        .post(ROLE_SERVICE.creatRole, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const addPermissionTask = createAsyncThunk('employeeRoles/addPermissionTask', async (body) => {
    const result = await apiInstance
        .post(ROLE_SERVICE.addPermissionTask, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const updateRoleRestriction = createAsyncThunk('employeeRoles/updateRoleRestriction', async (body) => {
    const result = await apiInstance
        .put(ROLE_SERVICE.updateRoleRestriction, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetSingleRole = createAsyncThunk('employeeRoles/GetSingleRole', async (id) => {
    const result = await apiInstance
        .get(`${ROLE_SERVICE.getSingleRole}${id}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const UpdateRole = createAsyncThunk('employeeRoles/UpdateRole', async (body) => {
    const result = await apiInstance
        .put(ROLE_SERVICE.updateRole, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
